module.exports = __webpack_public_path__ + "media/images/web/home/platform/header_img-cc3bf9084b2eeb59146a13afa18153a3.jpg";